import React from 'react';

const InfoIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.99935 19.3334C15.154 19.3334 19.3327 15.1547 19.3327 10C19.3327 4.84536 15.154 0.666687 9.99935 0.666687C4.84469 0.666687 0.666016 4.84536 0.666016 10C0.666016 15.1547 4.84469 19.3334 9.99935 19.3334Z"
      fill="#F4F1F5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 5C9.44772 5 9 5.44772 9 6C9 6.55228 9.44772 7 10 7H10.0111C10.5634 7 11.0111 6.55228 11.0111 6C11.0111 5.44772 10.5634 5 10.0111 5H10ZM11 10C11 9.44772 10.5523 9 10 9C9.44772 9 9 9.44772 9 10V14C9 14.5523 9.44772 15 10 15C10.5523 15 11 14.5523 11 14V10Z"
      fill="#1A171E"
    />
  </svg>
);

export default InfoIcon;
